<app-main-contents>
  <app-breadcrumbs [label2]="title"></app-breadcrumbs>
  <app-title [title]="title"></app-title>
  <app-update-customer-form
    [customerCd]="customerCd"
  ></app-update-customer-form>
</app-main-contents>
